import { ArrowRight, FileSpreadsheet } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { Link } from 'react-router-dom';

import { Card, CardContent } from '@/ui/base/card';
import { Button } from '@/ui/base/button';
import { formatarDinheiro } from '@/nucleo/dinheiro';

import type { ResumoMes } from './tipos';

const fmtInt = new Intl.NumberFormat('pt-BR');

/**
 * Bloco-resumo no topo do Painel Executivo: KPIs consolidados do mês fechado,
 * com atalho para a tela completa de indicadores mensais.
 */
export function ResumoIndicadoresMes({ dados }: { dados: ResumoMes }) {
  const mesLabel = format(new Date(`${dados.mesReferencia}T00:00:00`), "MMMM 'de' yyyy", {
    locale: ptBR,
  });

  const kpis = [
    { label: 'Bruto (PF+PJ)', value: formatarDinheiro(dados.brutoTotal) },
    { label: 'Crianças transp.', value: fmtInt.format(dados.criancasTransportadas) },
    { label: 'Frota ativa', value: fmtInt.format(dados.frotaAtiva) },
    { label: 'Condutores', value: fmtInt.format(dados.condutores) },
  ];

  return (
    <Card className="rounded-2xl border-primary/20 bg-linear-to-br from-primary/5 to-transparent">
      <CardContent className="p-4 sm:p-5">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
          <div className="flex min-w-0 items-start gap-3">
            <div className="shrink-0 rounded-xl bg-primary/10 p-2">
              <FileSpreadsheet className="h-5 w-5 text-primary" aria-hidden />
            </div>
            <div className="min-w-0">
              <p className="text-xs uppercase tracking-wider text-muted-foreground">
                Indicadores do mês · {mesLabel}
              </p>
              <p className="mt-0.5 text-sm text-foreground/90">
                Resumo operacional consolidado por DRE e regime (PF/PJ).
              </p>
            </div>
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <div className="flex flex-wrap items-center gap-x-5 gap-y-2">
              {kpis.map((k) => (
                <div key={k.label} className="min-w-[110px]">
                  <p className="text-[10px] uppercase tracking-wider text-muted-foreground">
                    {k.label}
                  </p>
                  <p className="text-base font-bold leading-tight tabular-nums">{k.value}</p>
                </div>
              ))}
            </div>
            <Button asChild size="sm" className="shrink-0 gap-1.5">
              <Link to="/operacao/financeiro/indicadores-mensais">
                Relatório completo <ArrowRight className="h-4 w-4" aria-hidden />
              </Link>
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
